export default "/images/silent-hill-shotgun.png";